import ClientListPage from './client-list';

export default ClientListPage;